import { Toast } from 'antd-mobile';
import dayjs from 'dayjs';
import { formatter } from './mathWays';
import JSEncrypt from 'jsencrypt';
import UAParser from 'ua-parser-js';

const ua = navigator.userAgent;
export const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
export const isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
export const isWindows = !!ua.match(/Windows/i);
export const isMacOS = !!ua.match(/Macintosh/i);

export const preload = (url: string, type: string, as: string) => {
  const link = document.createElement('link');
  link.rel = 'preload';
  link.href = url;
  link.as = as;
  link.type = type;
  document.head.appendChild(link);
};

export const prefetch = (url: string, type: string, as: string) => {
  const link = document.createElement('link');
  link.rel = 'prefetch';
  link.href = url;
  link.as = as;
  link.type = type;
  document.head.appendChild(link);
};

// 文本复制到剪贴板
export const copyText = (text, callback?) => {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    // 使用现代浏览器的 clipboard API
    return navigator.clipboard
      .writeText(text)
      .then(function () {
        Toast.show({
          icon: 'success',
          // duration: 800,
          content: 'foi copiado'
          // afterClose: () => callback && callback()
        });
        callback && callback();
      })
      .catch(function (err) {
        console.error('Failed to copy text: ', err);
        Toast.show({
          icon: 'fail',
          content: 'Failed to copy text'
        });
      });
  } else {
    // 回退方法，适用于旧版浏览器
    return new Promise<void>(function (resolve, reject) {
      const textArea = document.createElement('textarea');

      // 创建一个临时的文本区域元素
      textArea.value = text;
      document.body.appendChild(textArea);

      // 选中该文本区域的文本内容
      textArea.select();
      textArea.setSelectionRange(0, textArea.value.length); // for mobile devices
      try {
        // 执行复制命令
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (successful) {
          Toast.show({
            icon: 'success',
            content: 'foi copiado'
            // duration: 1000,
            // afterClose: () => callback && callback()
          });
          callback && callback();
          resolve();
        } else {
          throw new Error('Copy command was unsuccessful.');
        }
      } catch (err) {
        console.error('Failed to copy text: ', err);
        document.body.removeChild(textArea);
        Toast.show({
          icon: 'fail',
          content: 'Failed to copy text'
        });
        reject(err);
      }
    });
  }
};

export const isSupportPWA = () => {
  return 'serviceWorker' in navigator;
};

// 检测是否在pwa应用中
export const isInPWA = () => {
  const displayModes = ['fullscreen', 'standalone', 'minimal-ui'];
  return displayModes.some(
    mode => window.matchMedia(`(display-mode: ${mode})`).matches
  ) && !isIOS
};
// 检测是否添加到iOS桌面
export const isFromIOSScreen = () => {
  // @ts-ignore
  return window.navigator.standalone && isIOS;
};
// 检测是否是facebook浏览器
const isFacebookApp = (): boolean => {
  const parser = new UAParser(navigator.userAgent);
  const browserName = parser.getBrowser().name;

  // 检查浏览器名称是否包含Facebook相关标识
  return /FBAV|FBAN|FBIOS|FB|FACEBOOK/i.test(browserName || '');
};

// 检测是否在浏览器app中
const isInBrowserApp = (): boolean => {
  const ua = navigator.userAgent.toLowerCase();
  return /Chrome|Firefox|Safari|Opera|Edge|IE|Chromium|Vivaldi|Brave|Epic|Yandex|Maxthon|SeaMonkey|QQBrowser|UCBrowser|Tor Browser/i.test(ua);
};

export const isWebView = /wv|WebView/i.test(navigator.userAgent);
// @ts-ignore
export const hasAndroidBridge = typeof window.jsBridge !== 'undefined';

// @ts-ignore
// 检测是否是在ios app且不在facebook浏览器且不在浏览器app中
export const isInIosApp = isIOS && (!!window.webkit && !!window.webkit.messageHandlers) && !isFacebookApp() && !isInBrowserApp();
const urlParams = new URLSearchParams(location.search.split('?')[1]);
export const isInAndroidApp = isAndroid && (
  urlParams.get('platform') == 'android' ||
  localStorage.platform == 'android' ||
  (isWebView && hasAndroidBridge)
) // android webview
export const isInApp = () => {
  return isInIosApp || isInAndroidApp;
};

export const PWA_Installed = '__yz_pwa_installed__';

// 检测是否已安装pwa
export const isInstallPWA = localStorage.getItem(PWA_Installed);

export const generateRandomImagePath = () => {
  const randomNumber = Math.floor(Math.random() * 57) + 1; // 生成 1 到 57 的随机数
  const formattedNumber = randomNumber.toString().padStart(2, '0'); // 格式化为两位数
  return `/${formattedNumber}.png`; // 创建完整的路径字符串
};

export const downFile = (url, fileName) => {
  // const url = window.URL.createObjectURL();
  const a = document.createElement('a');
  a.href = url;
  a.target = '_self';
  a.download = fileName;
  //   a.href = 'javascript:void(0);';
  a.style.display = 'none';
  document.body.append(a);
  a.click();
  setTimeout(() => {
    a?.remove();
  }, 200);
};

export const readText = async () => {
  try {
    // 尝试读取剪贴板内容
    const text = await navigator.clipboard.readText();
    return text;
  } catch (err) {
    console.error('Failed to read clipboard contents: ', err);
    throw err; // 将错误抛出以便调用者处理
  }
};

const baseURL = import.meta.env.VITE_IMAGE_URL; // import.meta.env.VITE_BASE_URL;

export const getImagePath = name => {
  if (name) {
    return `${baseURL}${name}`;
  } else {
    return `data:image/png;base64,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`;
  }
};

// 次数
export const renderCount = (v, unit = 'K') => {
  if (v < 1000) {
    return v;
  } else {
    return Math.floor(v / 1000) + unit;
  }
};


export function getNextTimeSlotCountdown(timeSlots) {
  const now = dayjs(dayjs().utc().format('YYYY-MM-DD HH:mm:ss')); // 获取当前时间,一定要这样 包一下，不然还是diff的时候还是计算当前的时区
  let closestTimeDiff: any = null;

  for (const slot of timeSlots) {
    // 今天时间段
    const currentDayStart = dayjs(`${now.format('YYYY-MM-DD')} ${slot.start}`);

    // 第二天时间段
    const nextDayStart = currentDayStart.add(1, 'day');

    // 判断是今天的时间段还是明天的时间段
    const start = currentDayStart.isAfter(now) ? currentDayStart : nextDayStart;

    const diff = start.diff(now); // 计算时间差

    if (closestTimeDiff === null || diff < closestTimeDiff) {
      closestTimeDiff = diff;
    }
  }

  return closestTimeDiff;
}

// 格式化倒计时为 HH:mm:ss
export function formatCountdown(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const hours = Math.floor(totalSeconds / 3600)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((totalSeconds % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (totalSeconds % 60).toString().padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

// 截取小数点后两位数字，非四舍五入
export function truncateToTwoDecimalPlaces(number) {
  // 将数字转换为字符串
  const numberString = number.toString();
  // 查找小数点的位置
  const decimalIndex = numberString.indexOf('.');
  if (decimalIndex === -1) {
    // 如果没有小数点，返回原始数字
    return number;
  }
  // 截取到小数点后两位
  const truncatedString = numberString.substring(0, decimalIndex + 3);
  // 将截取后的字符串转换回数字
  return parseFloat(truncatedString);
}
// 将utc时间d段转为当前本地时间
export function convertUTCToLocalTime(timeString) {
  // 获取当前日期
  const todayDate = dayjs().format('YYYY-MM-DD');

  // 将日期和时间组合在一起，并将其视为 UTC 时间
  const timeInUTC = dayjs.tz(
    `${todayDate} ${timeString}`,
    'YYYY-MM-DD HH:mm',
    'UTC'
  );

  // 转换为本地时间
  const timeInLocal = timeInUTC.local();

  // 返回本地时间的小时和分钟
  return timeInLocal.format('HH:mm');
}

/**
 * 获取指定范围的开始时间和结束时间
 * @param {string} range - 日期范围类型（"今日", "昨日", "本周", "本月", "上月", "近三个月"）
 * @returns {Object} 包含开始时间和结束时间的对象
 */
export function getDateRange(range) {
  let start, end;

  switch (range) {
    case 'Hoje': //今日
      start = dayjs().startOf('day');
      end = dayjs().endOf('day');
      break;
    case 'Ontem': //昨日
      start = dayjs().subtract(1, 'day').startOf('day');
      end = dayjs().subtract(1, 'day').endOf('day');
      break;
    case 'Esta semana': // 本周
      start = dayjs().startOf('week');
      end = dayjs().endOf('week');
      break;
    case 'Este mês': // 本月
      start = dayjs().startOf('month');
      end = dayjs().endOf('month');
      break;
    case 'Mês passado': //上月
      start = dayjs().subtract(1, 'month').startOf('month');
      end = dayjs().subtract(1, 'month').endOf('month');
      break;
    case 'Últimos três meses': //近三个月
      end = dayjs().endOf('day');
      start = dayjs().subtract(90, 'day').startOf('day');
      break;
    default: //默认今日
      start = dayjs().startOf('day');
      end = dayjs().endOf('day');
  }

  return [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
}

// 显示正负数的颜色
export const classObject = value => {
  return {
    'text-[#FF3232]': Number(value) < 0,
    'text-[#41EB32]': Number(value) > 0
  };
};
// 显示正负数
export const showNumber = value => {
  if (value > 0) {
    return `+${formatter.format(value)}`;
  } else if (value < 0) {
    return `${formatter.format(value)}`;
  } else {
    return formatter.format(value);
  }
};

// 格式化成巴西时间格式
export const formatDateInPortuguese = dateString => {
  const months = [
    'jan.',
    'fev.',
    'mar.',
    'abr.',
    'mai.',
    'jun.',
    'jul.',
    'ago.',
    'set.',
    'out.',
    'nov.',
    'dez.'
  ];
  const date = dayjs(dateString);
  const day = date.date();
  const month = months[date.month()];
  const year = date.year();
  const hours = date.hour().toString().padStart(2, '0');
  const minutes = date.minute().toString().padStart(2, '0');
  const seconds = date.second().toString().padStart(2, '0');

  return `${day} de ${month} de ${year} ${hours}:${minutes}:${seconds}`;
};

export const handleHost = (host: string) => {
  return host?.startsWith('www') ? host?.slice(4) : host;
};

export const isFromDrainageWebsite = () => {
  const drainageArr = ['facebook', 'instagram'];
  return drainageArr.some(item => document.referrer.includes(item));
};

export const getGameUrl = (item, language) => {
  const icon = item?.customIcon || item?.icon;
  if (icon) {
    if (icon.startsWith('http')) {
      return icon;
    } else {
      return `/images/${language}/${icon}.jpg`;
    }
  } else {
    return `/images/${language}/${item.gameId}.jpg`;
  }
};

//密码加密
export const encryptPassword = password => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(
    'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAy0vLmwmUYOQQ9vgxeCHnlPEvUfU3DF3BZWSPkJ8RTbIyCeCzyPtOjKfCKunb8FQcLUyJ+Rg49rMhhZerq+/tKoLhMNVaMAUFedSH7IrfbqqdEE+1zGoHGGE8LHmx/4xrbFB9e+e24kxRKuN6oUA1DpiJi+RjMuaVQCVhIdZ77LaeUFTIWMkot5nr3PIi4lNI9bNWs3hcRpeMz5+zi4Lfvl5on9w4LXGDT9qxxn1PhBtkmo3R3nQ08PNK9tQ6/N1CJ0dAk6tFzcbRe4BmSot+ZPS10tE6dFQ0KTQC7Y03Te4XFdwBQNNOjtxw/jfO33ubPfkWzfBouZKBXcpFIGC1+wIDAQAB'
  );
  return encryptor.encrypt(password);
};

// 加密文本
export const encryptTxt = txt => {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(
    'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCz/kF7jiIcmPjn7H9DvpY8JBXDYkXGXjcui7YGEylv3AJ9C4j163M05nV / MvPlDOBcAkcku0mmuFvOye + y3pLwJ8E7bZlv5va5LVZu8tvmmYwAipQ1By8FDSvS7rAWYFFjs5eFIJJkDILs6X9rLhQym + jLJwBCCFtkVvAMAttWRQIDAQAB'
  );
  return encryptor.encrypt(txt);
};

export const isLogin = () => localStorage.getItem('userInfo');

export const getS3Url = pathname => {
  const idProduction = import.meta.env.VITE_ENV === 'production';
  const fullPath = idProduction
    ? `//c.dxv5w1efv6.xyz/${pathname}`
    : `//bw-front-end-resouce-dev.s3.sa-east-1.amazonaws.com/${pathname}`;
  return `${fullPath}`;
};

export const checkPined = (
  el: HTMLElement & { _t?: HTMLElement },
  check = async el => el.getBoundingClientRect().top <= 1,
  times = 3
) => {
  if (el._t) return () => {};

  const offsetObj = document.createElement('div');
  el._t = offsetObj;
  // offsetObj.style.height = '.1px';
  el.parentNode!.insertBefore(offsetObj, el);

  const run = async n => {
    if (n > 0) {
      const pinned = await check(el);
      if (pinned) {
        el.classList.add('pinned');
      } else {
        el.classList.remove('pinned');
      }
      requestAnimationFrame(() => run(n - 1));
    }
  };
  const intersectionObserver = new IntersectionObserver(entries => {
    run(times);
  });

  intersectionObserver.observe(offsetObj);

  return () => {
    intersectionObserver.unobserve(offsetObj);
  };
};

export const gotoActivity = (link, activityId, search = location.search) => {
  const newParams = new URLSearchParams(search);
  if (activityId) newParams.set('activityId', activityId);

  const url = `${link}?${newParams}`
  location.href = url
};
